/* ────────────────────────────────────────────────────────────────
   Kushface — Broadcast channel-change flash
   One-shot CMY color-separation overlay, ~120ms total.
   Exposes: window.kfBroadcastFlash()
   Respects prefers-reduced-motion (becomes a no-op).
   ──────────────────────────────────────────────────────────────── */
(function () {
  "use strict";

  var prefersReduced = window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var stage = null;
  function ensureStage() {
    if (stage) return stage;
    stage = document.createElement("div");
    stage.className = "kf-flash";
    stage.setAttribute("aria-hidden", "true");
    stage.innerHTML =
      '<span class="kf-flash__layer kf-flash__layer--c"></span>' +
      '<span class="kf-flash__layer kf-flash__layer--m"></span>' +
      '<span class="kf-flash__layer kf-flash__layer--y"></span>';
    document.body.appendChild(stage);
    return stage;
  }

  function fire() {
    if (prefersReduced) return;
    var s = ensureStage();
    s.classList.remove("is-firing");
    // Force reflow so the animation restarts cleanly on repeated triggers.
    void s.offsetWidth;
    s.classList.add("is-firing");
    window.setTimeout(function () {
      s.classList.remove("is-firing");
    }, 220);
  }

  window.kfBroadcastFlash = fire;
})();
